




















import { Component, Vue } from 'vue-property-decorator';

const CardProps = Vue.extend({
  props: {
    entry: Object,
  },
});

@Component
export default class Card extends CardProps {

}
